import React from 'react'
import { LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import ReactDOM from 'react-dom'
import type { RichTextParagraph } from '../domain/richText/types.no-deps'
import { CommentAdder, type Props } from '../../app-core/lib/commentTimeline/CommentAdder'
import type { Profile } from '../../app-core/lib/user/Profile'
import type { SupportedLanguage } from '../i18n/types.no-deps'

enum Events {
    onSubmit = 'on-submit',
    onAction = 'on-action',
}

interface EventDetail {
    [Events.onSubmit]: RichTextParagraph[]
    [Events.onAction]: null
}

@customElement('zaptic-comment-adder')
export class CommentAdderWrapper extends LitElement implements Props {
    @property({ attribute: 'profiles', type: Object })
    profiles: Profile[]

    @property({ attribute: 'author-profile', type: Object })
    authorProfile: Profile

    @property({ attribute: 'disabled', type: Boolean })
    disabled: boolean

    @property({ attribute: 'show-action', type: Boolean })
    showAction: boolean

    @property({ attribute: 'language', type: String })
    language: SupportedLanguage

    private triggerEvent<E extends Events>(event: E, detail: EventDetail[E], composed = true) {
        this.dispatchEvent(new CustomEvent(event, { detail, composed }))
    }

    onSubmit = async (content: RichTextParagraph[]) => {
        this.triggerEvent(Events.onSubmit, content)
    }

    onAction = () => {
        this.triggerEvent(Events.onAction, null)
    }

    public createRenderRoot() {
        return this
    }

    public render() {
        ReactDOM.render(
            <CommentAdder
                profiles={this.profiles}
                language={this.language}
                authorProfile={this.authorProfile}
                disabled={this.disabled}
                onAction={this.showAction && this.onAction}
                onSubmit={this.onSubmit}
            />,
            this
        )
    }
}
